// extracted by mini-css-extract-plugin
module.exports = {"red":"SubscriptionBadge__red___af1BM"};